import { render, staticRenderFns } from "./passagewayReport.vue?vue&type=template&id=0ba5dee6&"
import script from "./passagewayReport.vue?vue&type=script&lang=js&"
export * from "./passagewayReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports